<template>
  <div>
    <v-avatar
      v-for="(color,inc) in colors"
      :key="inc+Math.random()+Math.random()"
      class="mx-1"
      size="45"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" color="white">{{color.icon}}</v-icon>
          <input
            type="color"
            id="favcolor"
            :value="color.value"
            @input="pickColor(inc)"
            style="border-radius:50%"
          />
        </template>
        <span>{{color.tooltip}}</span>
      </v-tooltip>
    </v-avatar>

    <v-menu left bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-format-header-1</v-icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list color="deep-purple accent-4">
        <v-list-item
          v-for="(header,hd) in headers"
          :key="hd+Math.random()+Math.random()+Math.random()"
        >
          <v-avatar class="mx-1" size="45">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="white" @click="formatHeaders(header.value)">{{header.icon}}</v-icon>
              </template>
              <span>{{header.tooltip}}</span>
            </v-tooltip>
          </v-avatar>
        </v-list-item>
      </v-list>
    </v-menu>

    <input
      id="imagePicker"
      type="file"
      style="display:none"
      ref="pickImage"
      accept="image/*"
      @change="loadImage()"
    />
    <v-avatar
      v-for="(toolbar,indt) in toolbars"
      :key="indt+Math.random()+Math.random()"
      class="mx-1"
      size="45"
      @click="format(toolbar.command,toolbar.value)"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" color="white">{{toolbar.icon}}</v-icon>
        </template>
        <span>{{toolbar.tooltip}}</span>
      </v-tooltip>
    </v-avatar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      colors: [
        {
          icon: "mdi-format-color-fill",
          command: "backColor",
          tooltip: "Background Color",
          value: "#E1F700"
        },
        {
          icon: "mdi-format-color-text",
          command: "foreColor",
          tooltip: "Text Color",
          value: "#DD2C00"
        }
      ],
      headers: [
        {
          icon: "mdi-format-header-1",
          tooltip: "Header Level 1",
          value: "h1"
        },
        {
          icon: "mdi-format-header-2",
          tooltip: "Header Level 2",
          value: "h2"
        },
        {
          icon: "mdi-format-header-3",
          tooltip: "Header Level 3",
          value: "h3"
        },
        {
          icon: "mdi-format-header-4",
          tooltip: "Header Level 4",
          value: "h4"
        },
        {
          icon: "mdi-format-header-5",
          tooltip: "Header Level 5",
          value: "h5"
        },
        {
          icon: "mdi-format-header-6",
          tooltip: "Header Level 6",
          value: "h6"
        }
      ],

      toolbars: [
        // {
        //   icon: "mdi-format-paragraph",
        //   command: "insertParagraph",
        //   tooltip: "Insert Paragraph"
        // },
        { icon: "mdi-format-bold", command: "bold", tooltip: "Bold" },
        { icon: "mdi-format-italic", command: "italic", tooltip: "Italic" },
        // { icon: "mdi-content-cut", command: "cut", tooltip: "Cut" },
        // { icon: "mdi-content-copy", command: "copy", tooltip: "Copy" },
        // { icon: "mdi-content-paste", command: "paste", tooltip: "Paste" },
        { icon: "mdi-undo-variant", command: "undo", tooltip: "Undo" },
        { icon: "mdi-redo-variant", command: "redo", tooltip: "Redo" },
        {
          icon: "mdi-format-list-bulleted",
          command: "insertUnorderedList",
          tooltip: "Unordered List"
        },
        {
          icon: "mdi-format-list-bulleted-type",
          command: "insertOrderedList",
          tooltip: "Ordered List"
        },
        {
          icon: "mdi-image",
          command: "insertImage",
          tooltip: "Insert Image",
          value: this.uploadedImage
        },

        // {
        //   icon: "mdi-select-all",
        //   command: "selectAll",
        //   tooltip: "Select All"
        // },

        {
          icon: "mdi-format-subscript",
          command: "subscript",
          tooltip: "Subscript"
        },
        {
          icon: "mdi-format-superscript",
          command: "superscript",
          tooltip: "Superscript"
        },
        {
          icon: "mdi-format-underline",
          command: "underline",
          tooltip: "Underline"
        },

        {
          icon: "mdi-format-strikethrough-variant",
          command: "strikeThrough",
          tooltip: "Strike Through"
        },

        // { icon: "mdi-format-italic", command: "insertInputImage" },
        // { icon: "mdi-format-italic", command: "insertInputFileUpload" },
        // { icon: "mdi-format-italic", command: "insertInputCheckbox" },
        // {
        //   icon: "mdi-format-italic",
        //   command: "fontName",
        //   tooltip: "Font Family",
        //   value: "Arial"
        // },
        {
          icon: "mdi-format-align-left",
          command: "justifyLeft",
          tooltip: "Align Left"
        },

        {
          icon: "mdi-format-float-left",
          command: "indent",
          tooltip: "Indent Line"
        },
        {
          icon: "mdi-format-align-center",
          command: "justifyCenter",
          tooltip: "Align Center"
        },
        {
          icon: "mdi-format-align-right",
          command: "justifyRight",
          tooltip: "Align Right"
        },
        {
          icon: "mdi-format-align-justify",
          command: "justifyFull",
          tooltip: "Justify"
        }
        // { icon: "mdi-format-quote", command: "quote", tooltip: "Block Quote" },
        // {
        //   icon: "mdi-format-size",
        //   command: "mdi-format-size",
        //   tooltip: "Font Size"
        // },

        // {
        //   icon: "mdi-format-text",
        //   command: "insertText",
        //   tooltip: "Insert Text"
        // }
        // {
        //   icon: "mdi-format-rotate-90",
        //   command: "mdi-format-size",
        //   tooltip: "Rotate Text"
        // },
        // {
        //   icon: "mdi-format-pilcrow",
        //   command: "mdi-format-size",
        //   tooltip: "Cursor Shape"
        // },
        // {
        //   icon: "mdi-format-paint",
        //   command: "mdi-format-size",
        //   tooltip: "Paint"
        // },
        // {
        //   icon: "mdi-format-line-weight",
        //   command: "mdi-format-size",
        //   tooltip: "Line Weight"
        // },
        // {
        //   icon: "mdi-format-indent-decrease",
        //   command: "mdi-format-size",
        //   tooltip: "Indent Decrease"
        // },
        // {
        //   icon: "mdi-format-indent-increase",
        //   command: "mdi-format-size",
        //   tooltip: "Indent Increase"
        // },
      ]
    };
  },
  methods: {
    pickColor(index) {
      this.colors[index].value = event.target.value;
      this.format(this.colors[index].command, event.target.value);
    },
    format(command, value = null) {
      if (command == "insertImage") {
        this.$refs.pickImage.click();
        return;
      }
      document.execCommand(command, false, value);
    },
    loadImage() {
      const file = event.target.files[0];

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.uploadedImage = fileReader.result;
        document.execCommand("insertImage", false, fileReader.result);
      });
      fileReader.readAsDataURL(file);
    },
    formatHeaders(value) {
      const selText = document
        .getSelection()
        .toString()
        .trim();
      document.execCommand(
        "insertHTML",
        false,
        "<" + value + ">" + selText + "</" + value + ">"
      );
    }
  }
};
</script>

<style>
</style>